import React, { Component } from 'react';

import RadioButton from '../../common/radio_button/main';

export default class RadioButtons extends Component {
  state = {
    checkedButton: 'rbg'
  }

  updateRadioButton = (e) => {
    this.setState({ checkedButton: e.target.value });
  }

  render() {
    const { checkedButton } = this.state;

    return (
      <div className="radio-button-container example-container">
        <h3>Place where Logan eats lunch</h3>
        <RadioButton
          checkedButton={checkedButton}
          labelCopy="Will Call"
          name="styleguide-example"
          onChangeFunction={this.updateRadioButton}
          valueCopy="will-call"
        />
        <RadioButton
          checkedButton={checkedButton}
          labelCopy="RiNo Beer Garden (RBG)"
          name="styleguide-example"
          onChangeFunction={this.updateRadioButton}
          valueCopy="rbg"
        />
        <RadioButton
          checkedButton={checkedButton}
          labelCopy="Butcher Block"
          name="styleguide-example"
          onChangeFunction={this.updateRadioButton}
          valueCopy="butcher-block"
        />
        <RadioButton
          checkedButton={checkedButton}
          labelCopy="Taco Truck"
          name="styleguide-example"
          onChangeFunction={this.updateRadioButton}
          valueCopy="taco-truck"
        />

        <div className="html-example">
          <div>
            <span>
              {'<'}
              <span className="el">div</span>
              <span className="attr"> class</span>
=
              <span className="text">'radio-button-container'</span>
              {'>'}
            </span>
          </div>
          <div className="indent-1">
            <span>
              {'<'}
              <span className="el">label</span>
              <span className="attr"> class</span>
=
              <span className="text">'radio-row'</span>
              {'>'}
            </span>
          </div>
          <div className="indent-2">
            <span>
              {'<'}
              <span className="el">h4</span>
              {'>'}
Buthcer Block
              {'</'}
              <span className="el">h4</span>
              {'>'}
            </span>
          </div>
          <div className="indent-2">
            <span>
              {'<'}
              <span className="el">input</span>
              <span className="attr"> class</span>
=
              <span className="text">'radio-input'</span>
            </span>
          </div>
          <div className="indent-4">
            <span className="attr"> type</span>
=
            <span className="text">'radio'</span>
          </div>
          <div className="indent-4">
            <span className="attr"> name</span>
=
            <span className="text">'radio'</span>
          </div>
          <div className="indent-4">
            <span className="attr"> value</span>
=
            <span className="text">'butcher-block'</span>
          </div>
          <div className="indent-4">
            <span className="attr"> checked</span>
=
            {'{'}
ternary
            {'}'}
          </div>
          <div className="indent-4">
            <span className="attr"> onChange</span>
=
            {'{'}
function
            {'} />'}
          </div>
          <div className="indent-2">
            <span>
              {'<'}
              <span className="el">span</span>
              <span className="attr"> class</span>
=
              <span className="text">'radio-dot'</span>
              {'>'}
              {'</'}
              <span className="el">span</span>
              {'>'}
            </span>
          </div>
          <div className="indent-1">
            <span>
              {'</'}
              <span className="el">label</span>
              {'>'}
            </span>
          </div>
          <div>
            <span>
              {'</'}
              <span className="el">div</span>
              {'>'}
            </span>
          </div>
        </div>

      </div>
    );
  }
}
